import { translate } from "../../../util/translate"

export const splitConfigurationHeaders = [
  {
    text: translate['split.label.vendor'],
    value: 'vendor.name',
    width: 300,
  },
  {
    text: translate['split.label.hostTakeRate'],
    value: 'host_take_rate',
    align: 'right',
    width: 150,
  },
  {
    text: translate['split.label.customerTakeRate'],
    value: 'customer_take_rate',
    align: 'right',
    width: 150,
  },
  {
    text: translate['split.label.hausefulTakeRate'],
    value: 'hauseful_take_rate',
    align: 'right',
    width: 150,
  },
  {
    text: translate['split.label.partnerTakeRate'],
    value: 'partner_take_rate',
    align: 'right',
    width: 150,
  },
  { value: 'actions', align: 'right', width: 120 },
]
